import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "@/hooks/useTranslation";

export const ThankYouMessage = ({ form }: { form: any }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="thankYou.title"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('widgetBuilder.thankYouMessage.thankYouTitle')}</FormLabel>
            <FormControl>
              <Input {...field} placeholder={t('widgetBuilder.thankYouMessage.thankYouTitlePlaceholder')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="thankYou.message"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('widgetBuilder.thankYouMessage.thankYouMessage')}</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                placeholder={t('widgetBuilder.thankYouMessage.thankYouMessagePlaceholder')}
                className="min-h-[100px]"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};